export class ShowroomShortlistItem {
  variantSkuId: number;
  skuName: string;
  category: string;
  subCategory: string;
  imageUrl: string;
  thumbnailImageUrl: string;
}
